import React from 'react';
import AffiliationBanner from '../../../assets/sectionBanners/Bottom_Banner_WEB.webp';
import AffiliationBannerMob from '../../../assets/sectionBanners/Bottom_Banner_MOB.webp';
import AffiliationBannerTab from '../../../assets/sectionBanners/Bottom_Banner_TABLET.webp';
import ImageBanner from '../../ImageBanner/ImageBanner';
import useDeviceType from '../../../hooks/useDeviceType';

const SectionBannerAffiliation = ({ t, baseClassName }) => {
    const { isMobileWidth, isTablet } = useDeviceType();

    return (
        <ImageBanner
            image={AffiliationBanner}
            mobileImage={AffiliationBannerMob}
            tabletImage={AffiliationBannerTab}
            className={
                isTablet
                    ? isMobileWidth
                        ? `${baseClassName}__affiliation_container-mobile`
                        : `${baseClassName}__affiliation_container-tablet`
                    : `${baseClassName}__affiliation_container`
            }
        >
            <div
                className={`${baseClassName}__affiliation 
                ${isTablet ? `${baseClassName}__affiliation-tablet` : ''} ${
                    isMobileWidth ? `${baseClassName}__affiliation-mobile` : ''
                }`}
            >
                <h2 className={`${baseClassName}__affiliation_title`}>
                    {t('Section.Banner.Affiliation.title')}
                    <span style={{ verticalAlign: 'super', fontSize: '0.6em' }}>®</span>
                </h2>   
                <div className={`${baseClassName}__affiliation_description`}>
                    {t('Section.Banner.Affiliation.paragraph1')}
                </div>
            </div>
        </ImageBanner>
    );
};

export default SectionBannerAffiliation;
